import React from 'react';
import Box from './box';

const DangerBox = props => <Box className="alert-danger" alignment={props.alignment}>
  {props.children}
</Box>;
export default DangerBox;
